import Vue from "vue";
import Vuex from "vuex";
import router from '../router/index.js'
const User = {
    namespaced: true,
    state: {
        users: [],
        userSelected: {
            addressCity: "",
            addressCountry: "",
            addressExt: "",
            addressName: "",
            addressNum: "",
            addressPostalCode: "",
            addressType: "",
            corporationAgent: "",
            corporationAgentTitle: "",
            corporationName: "",
            corporationSiret: "",
            department: null,
            email: "",
            epci: null,
            firstName: "",
            lastName: "",
            id: null,
            picture: null,
            disableMails: false,
            allowDelete: false,
            nature: "",
            perimeterType: "",
            phone: "",
            phoneIndicative: "",
            roles: [],
            title: "",
            town: null
        },
        pagination: {},
        titles: [{
            value: "Monsieur",
            text: "M."
        },
        {
            value: "Madame",
            text: "Mme"
        },
        {
            value: "Monsieur Madame",
            text: "M. Mme"
        },
        ],
        natures: [
            { value: "Particulier", text: "Particulier" },
            {
                value: "Service public",
                text: "Service public"
            },
            {
                value: "Maître d'ouvrage ou son représentant",
                text: "Maître d'ouvrage ou son représentant"
            },
            {
                value: "Entreprise",
                text: "Entreprise"
            }
        ],
    },
    actions: {
        setUser(context, user) {
            context.commit("GETUSER", user);
        },
        initUser(context) {
            return new Promise((resolve, reject) => {
                let user = {
                    addressCity: "",
                    addressCountry: "",
                    addressExt: "",
                    addressName: "",
                    addressNum: "",
                    addressPostalCode: "",
                    addressType: "",
                    corporationAgent: "",
                    corporationAgentTitle: "",
                    corporationName: "",
                    corporationSiret: "",
                    department: null,
                    email: "",
                    epci: null,
                    firstName: "",
                    lastName: "",
                    id: null,
                    picture: null,
                    disableMails: false,
                    allowDelete: false,
                    nature: "",
                    perimeterType: "",
                    phone: "",
                    phoneIndicative: "",
                    roles: [],
                    title: "",
                    town: null,
                    managerPerimeter: {

                    },
                    ticketOfficePerimeter: {

                    },

                    sousTraitantPerimeter: {

                    },

                    operatorPerimeter: {

                    },
                }
                context.commit("GETUSER", user);
                resolve();
            })
        },

        getUsers(context, pagination) {

            let page = "?page=" + pagination.page;

            let searchText = "&searchText=" + pagination.searchText;

            let searchFilter = "&searchFilter=" + JSON.stringify(pagination.searchFilter);

            let searchSort = "&searchSort=" + pagination.searchSort;
            let searchDir = "&searchDir=" + pagination.searchDir;


            Vue.axios.get(window.urlapi + "stduser" + page + searchText + searchFilter + searchSort + searchDir).then(
                response => {
                    context.commit("GETUSERS", response.data.data);
                    context.commit("SETPAGINATION", response.data.pagination);
                },
            );
        },

        deleteUser(context, user) {
            Vue.axios.delete(window.urlapi + "stduser/" + user.id).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        context.commit("REMOVEUSER", user);
                    }
                },
            );
        },

        toggleUserDisabled(context, payload) {
            Vue.axios.put(window.urlapi + "stduser/" + payload.id + "/disabled", { disabled: payload.disabled }).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        context.commit("UPDATEUSERINLIST", {
                            id: payload.id,
                            disabled: response.data && response.data.data ? response.data.data.disabled : payload.disabled
                        });
                    }
                },
            );
        },
        
        updatePassword(context, user) {
            Vue.axios.put(window.urlapi + "stduser/" + user.id + "/password", user).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        context.commit("GETUSER", response.data.data);
                        if (user.password && user.password != 'secret' && user.passwordConfirm) {
                            router.push({
                                path: '/login'
                            })
                        }
                    }
                },
            );
        },
        updateUser(context, user) {
            Vue.axios.put(window.urlapi + "stduser/" + user.id, user).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        context.commit("GETUSER", response.data.data);
                        if (user.password && user.password != 'secret' && user.passwordConfirm) {
                            router.push({
                                path: '/login'
                            })
                        }
                    }
                },
            );
        },

        addUser(context, user) {
            Vue.axios.post(window.urlapi + "stduser", user).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        router.push({
                            name: 'Users'
                        })
                    }
                },
            );
        },
        getUser(context, id) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "stduser/" + id).then(
                    response => {

                        context.commit("GETUSER", response.data.data);
                        resolve();
                    },
                );
            })
        }
    },
    mutations: {
        SETPAGINATION: (state, pagination) => {
            state.pagination = pagination;
        },
        REMOVEUSER: (state, user) => {
            let index = state.users.findIndex(item => item.id == user.id);
            state.users.splice(index, 1)
        },
        GETUSERS: (state, users) => {
            state.users = users;
        },
        UPDATEUSERINLIST: (state, payload) => {
            const index = state.users.findIndex(item => item.id === payload.id);
            if (index !== -1) {
                state.users[index].disabled = !!payload.disabled;
            }
        },
        GETUSER: (state, user) => {
            user.ticketOfficePerimeterId = (user.ticketOfficePerimeter != null) ? user.ticketOfficePerimeter.id : null;
            user.managerPerimeterId = (user.managerPerimeter != null) ? user.managerPerimeter.id : null;
            user.sousTraitantPerimeterId = (user.sousTraitantPerimeter != null) ? user.sousTraitantPerimeter.id : null;
            user.operatorPerimeterId = (user.operatorPerimeter != null) ? user.operatorPerimeter.id : null;
            user.managerPerimeter = (user.managerPerimeter != null) ? user.managerPerimeter : { id: null, type: null, libelle: null };
            user.poleId = (user.pole != null) ? user.pole.id : null;
            state.userSelected = user;
        }
    },
    getters: {
        pagination: state => {
            return state.pagination;
        },
        natures: state => {
            return state.natures;
        },
        titles: state => {
            return state.titles;
        },
        users: state => {
            return state.users;
        },
        userById: state => id => {
            let result = state.users.find(item => item.id === id);
            return result;
        },
        countUsers: state => {
            return state.users.length;
        },
        userSelected: state => {
            return state.userSelected;
        }
    },
    modules: {}
};

export default User;